import { useState, useCallback } from 'react';
import {
  Button,
  ButtonContainer,
  Callout,
  Paragraph,
  Spinner,
  ContentSection,
  Checkbox
} from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';
import CustomerIndexService from '../../services/CustomerIndexService';
import { BrandType } from '@bus/models';

export const CustomerHappiness = () => {
  const chiService = new CustomerIndexService();

  const [isLoading, setIsLoading] = useState(false);
  const [isConsentAccepted, setIsConsentAccpeted] = useState(false);
  const { t } = useTranslation('chi');
  const { transactionId } = useAuth();
  const brand = process.env.REACT_APP_WEBSITE_BRAND as string;


  const goToQuestionnaire = useCallback(async () => {
    const newTab = window.open('', '_blank');
    setIsLoading(true);

    try {
      const { data } = await chiService.getChiLink(brand, transactionId);
      const url = data?.redirectUrl;
      if (!url) {
        newTab?.close();
        return;
      }
      if (newTab) {
        newTab.location.href = url;
        return;
      }
    } finally {
      setIsLoading(false);
    }
  }, [chiService, brand, transactionId]);

  const handleOnChange = useCallback(() => {
    setIsConsentAccpeted(!isConsentAccepted)
  }, [isConsentAccepted])

  const calloutTitle = t('chi:beforeSubmit:title');
  const text = t('chi:beforeSubmit:text');
  const consent = t('chi:beforeSubmit:consent');

  const renderChiSubmissionUi = () => {
    return (
      <>
        <ButtonContainer className="u-mt" center>
          <Button aria-label={t('chi:beforeSubmit.button')} ariaDisabled={!isConsentAccepted} disabled={!isConsentAccepted} onClick={goToQuestionnaire}>
            {isLoading ? <Spinner section center small /> : t('chi:beforeSubmit.button')}
          </Button>
        </ButtonContainer>
      </>
    );
  };

  return (
    <>
      <ContentSection>
        <Callout
          testId="customerHappinessWidget"
          title={calloutTitle}
          headingLevel={2}
        >
          <Paragraph>{text}</Paragraph>
          <Checkbox onChange={handleOnChange} checked={isConsentAccepted}>
            <Paragraph
              className={[BrandType.SKODA, BrandType.AUDI, BrandType.CUPRA].includes(brand as BrandType) ?
                'u-text-muted' :
                'u-text-white'
              }
            >{consent}</Paragraph>
          </Checkbox>
          {renderChiSubmissionUi()}
        </Callout>
      </ContentSection>

      <ContentSection pageWrap>
        <Paragraph
          className="c-footnotes"
        >
          {t('chi:beforeSubmit.legalNote')}<a href='https://www.vwfs.it/privacy-policy.html' target='_blank' rel="noreferrer"> (https://www.vwfs.it/privacy-policy.html)</a>.
          {t('chi:beforeSubmit.legalNote2')}<a href='https://policies.etrusted.com/IT/it/tos.html' target='_blank' rel="noreferrer" aria-label={t('chi:beforeSubmit.aria-label')}> (https://policies.etrusted.com/IT/it/tos.html)</a>.
          {t('chi:beforeSubmit.legalNote3')} <a href='https://www.vwfs.it/customer-happiness-index-trusted-shops.html#:~:text=Volkswagen%20Financial%20Services%20S.P.A.%C2%A0,-10554340967' target='_blank' rel="noreferrer"> (https://www.vwfs.it/customer-happiness-index-trusted-shops.html#:~:text=Volkswagen%20Financial%20Services%20S.P.A.%C2%A0,-10554340967)</a>.
        </Paragraph>
      </ContentSection>
    </>
  );
};
